import { render } from "./TFilters.vue?vue&type=template&id=2c078d1a"
import script from "./TFilters.vue?vue&type=script&lang=js"
export * from "./TFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__